type RequiredRules = {
  required: string;
  pattern: {
    value: RegExp;
    message: string;
  };
  validate?: (value: string) => true | string;
};

export const presenceNameValidation = (
  errorMessage: string,
  maxLength?: number
): RequiredRules => {
  const rules: RequiredRules = {
    required: errorMessage,
    pattern: { value: /^\s*[-a-zA-Z-]+\s*$/, message: errorMessage },
  };

  if (maxLength) {
    rules.validate = (value) =>
      value.trim().length <= maxLength || errorMessage;
  }

  return rules;
};
